import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Titulo from "../../components/atoms/titles/Titulo"
import { SpinnerCircle } from "../../components/atoms/spinner/Spinner";
import Header from "../../components/molecules/header/Header";
import Footer from "../../components/molecules/footer/Footer";
import { getMensajesReconocimientos } from "../../components/services/NivelCarreraService";


const RNSolicitudPDF = (object) => {
  const navigate = useNavigate();
  const params = useParams();
  

  const [loading, setLoading] = useState(false);
  const [solicitud, setSolicitud] = useState();
  const [mensaje, setMensaje] = useState();

  useEffect(() => {
    getMensajesReconocimientos(params.id).then((data) => {
      

      // setSolicitud(data)
      if (data.type === 'application/pdf') {
        var reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = function () {
          var base64data = reader.result;
          setSolicitud(base64data);
          setLoading(true);
        };
      } else {
        data.text().then((text) => {
          setMensaje(text); // Guarda el contenido textual
          setLoading(true); // Actualiza el estado
        }).catch((error) => {
          // console.error('Error al leer el mensaje:', error);
          setLoading(false); // Manejo de error
        });
      }
    })
  }, [params?.id])
  return (<>
    <Header />
    <div className="container-fluid" role="main" data-landmark-index="4">
      {loading ? (<>
        <div className="datosPersonalesCarrera d-flex flex-column m-2">
          <div>
            <div className="d-flex justify-content-between">
              <Titulo
                clases={"subSubTituloSolicitud p-2 fw-bold"}
                tipo={"tituloCard noBg"}
                titulo={`Reconocimiento`}
              ></Titulo>
            </div>
            <div className="separador"></div>
          </div>

          <div className="formulario">
            <>
              <div className="m-2"></div>
              <div className="m-3 card scroll-list container-list-border">
                <div className="gridPresentar">
                  <div className="iframePresentar pt-3">
                    {solicitud && !mensaje ? (
                      <object
                        data={solicitud}
                        type="application/pdf"
                        height="500"
                        width="100%"
                        aria-label="PDF del borrador"
                        className="rounded"
                        name="sol"
                      />
                    ) : !solicitud && mensaje ? (mensaje) : (
                      <p style={{ height: "500px", width: "100%" }}>
                        No se ha encontrado el documento en el
                        sistema.
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </>
            <div className="gridBotones mb-2">
              <button
                id="volver"
                className="btnRed rounded btnCancelarDocumentacion"
                type="button"
                onClick={() => navigate("/carrera")}
              >
                <i className="fa-solid fa-rotate-left"></i> Volver
              </button>
            </div>
          </div>
        </div>
      </>) : (<div className=""><SpinnerCircle /></div>)}
    </div>
    <Footer />
  </>)
}

export default RNSolicitudPDF;